<div class="bv-reports-grid">
  @for (report of reports(); track report.route) {
    <app-report-card
      [title]="report.title | i18n"
      [description]="report.description | i18n"
      [route]="report.route"
      [variant]="report.variant"
      [icon]="report.icon"
      [iconSrc]="report.iconSrc"
    ></app-report-card>
  }
</div>
